import { computed, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useAuthStore } from './auth'

export const useAccountStore = defineStore('account', () => {
  const auth = useAuthStore()
  const selectedId = ref<string | null>(localStorage.getItem('marketal.account'))
  const accounts = computed(() => (auth.viewer?.accounts ?? []).filter((account) => account.status === 'ACTIVE'))
  const selected = computed(() => accounts.value.find((account) => account.id === selectedId.value) ?? null)
  const canManage = computed(() => selected.value?.role === 'OWNER' || selected.value?.role === 'ADMIN')

  watch(
    accounts,
    (available) => {
      if (!auth.viewer) return
      if (!available.some((account) => account.id === selectedId.value)) {
        selectedId.value = null
        localStorage.removeItem('marketal.account')
      }
    },
    { immediate: true },
  )

  watch(selectedId, (value) => {
    if (value) localStorage.setItem('marketal.account', value)
    else localStorage.removeItem('marketal.account')
  })

  function select(accountId: string) {
    if (!accounts.value.some((account) => account.id === accountId)) {
      throw new Error('You do not have access to that account.')
    }
    selectedId.value = accountId
  }

  return { accounts, selectedId, selected, canManage, select }
})
